import React from "react";

const Demolitions = () => {
  return (
    <div className="wholeDiv">
      <div className="titleText">
        <b>Demolitions</b>
      </div>
      <div className="helpDescription">
        <b>Information about the Demolitions perk</b>
      </div>
      <div className="textBox">
        <div className="perkDescr">
          The <b>Demolitions</b> specializes in explosives, using heavy weaponry
          and high-damage area-of-effect attacks to clear out large groups of
          Zeds. The Demolitions perk emphasizes managing explosive devices like
          grenades, rocket launchers, and other high-impact weapons.
        </div>
        <div className="perkInfo">
          <b>Weapons</b>: The Demolitions has access to powerful explosive
          weapons, such as the Rocket Launcher, Grenade Launcher, and Pipe
          Bombs. These weapons deal massive damage over a wide area, making them
          perfect for eliminating groups of enemies quickly.
        </div>
        <div className="listText">
          <b>Benefits</b> acquired by leveling this perk:
          <div className="bonusList">
            <ul>
              <li>Bonuses for Demolitions weapons:</li>
              <ul>
                <li>Increase in explosive damage;</li>
                <li>Increase in fire speed;</li>
                <li>Increase in reload speed;</li>
                <li>Increase in amount ammunition magazines;</li>
                <li>Increase in pickup amount of ammunition;</li>
                <li>Discount on ammunition;</li>
                <li>Reduced weapon price;</li>
              </ul>
              <li>General bonuses:</li>
              <ul>
                <li>Increase in damage reduction;</li>
                <li>Increase in carry weight;</li>
                <li>Increase in recoil control;</li>
              </ul>
            </ul>
          </div>
          <b>Team Role</b>: Demolitions players are excellent at crowd control
          and dealing with large hordes or tough enemies that require high burst
          damage. They can clear out areas quickly, but need to be careful not
          to damage teammates in the process.
        </div>
      </div>
    </div>
  );
};

export default Demolitions;
